import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-04d4a1f7"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "slideWrap"
};
import { reactive, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import { slideSuccess, slideFaild } from '@/utils/navitiveApi/common';
import { showToast } from "vant";
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    scene: {
      type: String,
      default: ''
    },
    appkey: {
      type: String,
      default: ''
    },
    reload: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const route = useRoute();
    const data = reactive({
      reload: false,
      cls: false,
      scene: '',
      appkey: ''
    });
    watch(() => props.reload, newValue => {
      // if (newValue) {
      //     data.reload = newValue
      // }
      data.reload = newValue;
      console.log('props.reload', props.reload);
    });
    const slideSuccessHandle = result => {
      console.info('滑动成功', result);
      const param = {
        // 阿里云滑动验证码回传会话ID
        verificationSessionId: result.sessionId,
        // 阿里云滑动验证码回传签名串
        verificationSig: result.sig,
        // 阿里云滑动验证码回传请求唯一标识
        verificationToken: result.token
      };
      console.log('param', param);
      slideSuccess(JSON.stringify(param));
    };
    const slideErrorHandle = result => {
      console.info('滑动错误', result);
      showToast('滑动错误');
      slideFaild(JSON.stringify(result));
    };
    onMounted(() => {
      console.log('--通过原生调用滑块--, route.query.scene', route.query.scene, 'route.query.appKey', route.query.appKey);
      console.log('--通过原生h5调用滑块--, props.scene', props.scene, 'props.appkey', props.appkey);
      data.scene = props.scene || route.query.scene;
      data.appkey = props.appkey || route.query.appKey;
      console.info('****scene*****', data.scene, 'appkey', data.appkey);
    });
    return (_ctx, _cache) => {
      const _component_noCaptcha = _resolveComponent("noCaptcha");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_noCaptcha, {
        onSlideSuccessCallback: slideSuccessHandle,
        onSlideErrorCallback: slideErrorHandle,
        scene: data.scene,
        appkey: data.appkey,
        reload: data.reload
      }, null, 8, ["scene", "appkey", "reload"])]);
    };
  }
});